module.exports = __webpack_public_path__ + "img/img2.b9d6a1a7.png";